import {
  httpClient,
  apiRoutes,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

export type BindingWalletRequestParams = {
  payment_provider: string;
  return_url: string;
  c_id?: string;
};

export type ZalopayBindingWalletRes = {
  return_code: number;
  return_message: string;
  sub_return_code: number;
  sub_return_message: string;
  binding_token: string;
  deep_link: string;
  binding_qr_link: string;
  short_link: string;
};
export type ShopeepayBindingWalletRes = {
  status: string;
  redirect_url_web: string;
};
export type MomoBindingWalletRes = {
  deeplink: string;
  pay_url: string;
  payment_provider_log_id: string;
  qr_code_url: string;
  status: string;
};

export type BindingWalletRes =
  | ShopeepayBindingWalletRes
  | ZalopayBindingWalletRes
  | MomoBindingWalletRes;

export const postBindingWallet = async (body: BindingWalletRequestParams) => {
  const response = await httpClient.post(apiRoutes.payment.binding, body);
  return response.data;
};

export const usePostBindingWalletMutation = (
  opts?: UseMutationOptions<
    BindingWalletRes,
    DefaultQueryError,
    BindingWalletRequestParams
  >
) =>
  useMutation<BindingWalletRes, DefaultQueryError, BindingWalletRequestParams>({
    mutationFn: postBindingWallet,
    ...opts,
  });
